import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useEventTracking from '../common/hooks/useEventTracking';

const MixpanelTracker = (): null => {
  const location = useLocation();
  const { initialiseTracking, trackPageView, hasInitialised } =
    useEventTracking();

  useEffect(() => {
    initialiseTracking();
  }, []);

  useEffect(() => {
    if (hasInitialised) {
      trackPageView();
    }
  }, [location, hasInitialised]);

  return null;
};

export default MixpanelTracker;
